export enum MetadataType {
  RawAndLabeled = 'labeled',
  RawAndInferred = 'inferred',
  AssignedLabeled = 'assigned',
  InferredIdentities = 'inferred-identities',
  InferredRelations = 'inferred-relations',
  EqualEntities = 'equal-entities',
  Review = 'review',
}
